import { XML_AddPair } from "./XML_AddPair";
import { XML_ScaleAndShiftX } from "./XML_ScaleAndShiftX";
import { XML_ScaleAndShiftY } from "./XML_ScaleAndShiftY";
import { XML_Cmd2 } from "./XML_Cmd2";

export function XML_DrawBoxGroupHighlightPDF(
  xOffset,
  yOffset,
  poly,
  fillStyle,
  altCanvasElement,
  layer
) {
  var numPoints = poly.fPoints.length;

  if (numPoints > 0) {
    var point = poly.fPoints[numPoints - 1];
    var xStart = point.x + xOffset;
    var yStart = point.y + yOffset;
    var s = altCanvasElement.GetStream();
    var coords = {};
    altCanvasElement.OutputElementHead(s, "ph");
    XML_AddPair(
      XML_ScaleAndShiftX(xStart, altCanvasElement, layer),
      altCanvasElement.ConvertY(XML_ScaleAndShiftY(yStart, altCanvasElement, layer)),
      "mt",
      altCanvasElement
    );
    for (var i = 0; i < numPoints; i++) {
      var pointX = poly.fPoints[i].x;
      var pointY = poly.fPoints[i].y;
      var x1 = XML_ScaleAndShiftX(pointX + xOffset, altCanvasElement, layer);
      var y1 = XML_ScaleAndShiftY(pointY + yOffset, altCanvasElement, layer);
      y1 = altCanvasElement.ConvertY(y1);
      if (!(x1 in coords)) {
        coords[x1] = [];
      }

      XML_AddPair(x1, y1, "lt", altCanvasElement);
    }
    altCanvasElement.OutputElementTail(s, "ph");

    XML_Cmd2("stk", fillStyle ? fillStyle : "#ffffff", "0.5", altCanvasElement);
    XML_Cmd2("fi", fillStyle ? fillStyle : "#ffffff", "0.5", altCanvasElement);
  }
}
